import { ConcreteEncodable } from "./ConcreteEncodable";

import { BenchmarkVisibilityPairAndOwnerImplEncoder } from "../../encoder/BenchmarkVisibilityPairAndOwnerImplEncoder";

import * as CubiqTS from "../../index";
import { BenchmarkVisibilityPairAndOwner } from "../BenchmarkVisibilityPairAndOwner";

export class BenchmarkVisibilityPairAndOwnerImpl
  extends ConcreteEncodable
  implements BenchmarkVisibilityPairAndOwner
{
  public static enType: string = "com.bcdfx.benchmarks.model.BenchmarkVisibilityPairAndOwnerImpl";

  /*FID=1*/
  public baseCurrencyCd: string;
  /*FID=2*/
  public nonBaseCurrencyCd: string;
  /*FID=3*/
  public ownerGroupId: CubiqTS.Long | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = BenchmarkVisibilityPairAndOwnerImplEncoder.Instance;
    this.setEncodableType(BenchmarkVisibilityPairAndOwnerImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "BenchmarkVisibilityPairAndOwnerImpl[" +
      "baseCurrencyCd=" +
      this.baseCurrencyCd +
      "nonBaseCurrencyCd=" +
      this.nonBaseCurrencyCd +
      "ownerGroupId=" +
      this.ownerGroupId +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
